const requestDocumentTypeCodes = {
  EvidenciaPreConsultaPersonalIrregularAlFacilitador: 199,
  HRCertificadoMedicoHigiene: 201,
  HRCertificadoMedicoAlimentacion: 202,
  HRFormularioInformeMedicoParaDietasEspeciales: 203,
  HRMinuta: 204,
  HROtro: 205,
  HRCertificadoMedicoSalud: 206,
};

export default requestDocumentTypeCodes;
